<template>
  <zh-table-page
    ref="tableRef"
    v-bind="{
      initialForm,
      search,
      api,
      ...dialog,
      ...table,
      title: '字典类型',
    }"
  >
  </zh-table-page>
</template>
<script>
import {
  defineComponent,
  reactive,
  ref,
  toRefs,
  getCurrentInstance,
  onMounted,
  watch,
  computed,
} from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const tableRef = ref();
    const state = reactive({
      api: {
        list: "getDictTypeGetDictTpyeTreeBySelect",
        delete: "deleteDictTypeDelete",
        deleteAll: "",
        add: "postDictTypeSave",
        edit: "postDictTypeUpdate",
        exportAll: "",
        detail: null,
        path: "", //详情页面路由
      },
      table: {
        rowKey: "id",
        columns: [
          { label: "字典名称", prop: "dictName", align: "left" },
          { label: "字典类型", prop: "dictType" },

          { label: "备注", prop: "remark" },
          { label: "创建时间", prop: "createTime", width: "180" },
        ],
      },
      search: [
        {
          component: "zh-tree-select",
          placeholder: "请选择字典",
          value: "id",
          url: "getDictTypeGetDictTpyeTree",
          field: {
            id: "value",
            dictName: "label",
          },
          filterable: true,
        },
        {
          label: "字典类型",
          placeholder: "字典类型",
          value: "dictType",
        },
      ],
      dialog: {
        dialogForm: [
          {
            component: "zh-tree-select",
            label: "上级节点",
            placeholder: "请选择上级节点",
            value: "parentId",
            url: "getDictTypeGetDictTpyeTree",
            field: {
              id: "value",
              dictName: "label",
            },
            showCondition: (form) => {
              return form.parentId !== 0;
            },
          },
          {
            label: "字典名称",
            placeholder: "请输入字典名称",
            value: "dictName",
          },
          {
            label: "字典类型",
            placeholder: "请输入字典类型",
            value: "dictType",
            showCondition: (form) => {
              return form.parentId !== 0;
            },
          },
          {
            label: "备注信息",
            placeholder: "请输入内容",
            value: "remark",
            type: "textarea",
          },
        ],
        dialogRules: {
          parentId: [
            { required: true, message: "上级节点不能为空", trigger: "blur" },
          ],
          dictName: [
            { required: true, message: "字典名称不能为空", trigger: "blur" },
          ],
          dictType: [
            { required: true, message: "字典类型不能为空", trigger: "blur" },
          ],
          status: [{ required: true, message: "请选择状态", trigger: "blur" }],
        },
      },
      moreSearch: [],
      defaultBtns: {
        add: true,
      },
    });
    onMounted(() => {});

    const initialForm = (row) => {
      if (row) {
        return {
          parentId: row.id,
        };
      } else {
        return {};
      }
    };
    return {
      ...toRefs(state),
      tableRef,
      initialForm,
    };
  },
});
</script>
